import { Store } from "vuex";
import { ApiStatus } from "@/store/general.types";
import { screeningApi } from "@/api/screening.api";
import { Citation, Study, StudyNotesDTO } from "@/store/modules/study/study.types";
import { ScreeningState, ScreeningRecordPayLoad, StudyScreeningRecordsCountPayLoad, GetStudiesByScreeningTypeStatusPayload, GetStudiesByUserIdPayload, RevertDecisionPayload, UpdateStudyScreeningStatusPayload, RevertStudyScreeningDecisionPayload, StudyScreeningRecord, ResolveConflictPayload, ScreeningOverviewPayLoad, MergeStudiesPayload, StudyScreeningRecordsCount, StudyScreeningStatus } from "./screening.types";

export const screeningActions = {
    /**
     * JIRA: SUMDEV-2964
     * Updated to use new cluster-based counts endpoint
     */
    async getScreeningRecordsCount(store: Store<ScreeningState>, projectId: number) {
        try {
            store.commit('GET_SCREENING_RECORDS_COUNT', ApiStatus.LOADING);
            const { data } = await screeningApi.getScreeningRecordsCountV2(projectId);
            // Return V2 structure directly - no transformation needed
            store.commit('GET_SCREENING_RECORDS_COUNT', { data });
        } catch (error) {
            store.commit('GET_SCREENING_RECORDS_COUNT', { error });
        }
    },
    async getStudyScreeningRecordsCount(store: Store<ScreeningState>, studyScreeningRecordsCountPayload: StudyScreeningRecordsCountPayLoad) {
        try {
            store.commit('GET_STUDY_SCREENING_RECORDS_COUNT', ApiStatus.LOADING);
            const { data } = await screeningApi.getStudyScreeningRecordsCount(studyScreeningRecordsCountPayload);
            store.commit('GET_STUDY_SCREENING_RECORDS_COUNT', { data });
        } catch (error) {
            store.commit('GET_STUDY_SCREENING_RECORDS_COUNT', { error });
        }
    },
    async getScreeningOverviewCount(store: Store<ScreeningState>, screeningOverViewPayload: ScreeningOverviewPayLoad) {
        try {
            store.commit('GET_SCREENING_OVERVIEW_COUNT', ApiStatus.LOADING);
            const { data } = await screeningApi.getScreeningOverviewCount(screeningOverViewPayload);
            store.commit('GET_SCREENING_OVERVIEW_COUNT', { data });
        } catch (error) {
            store.commit('GET_SCREENING_OVERVIEW_COUNT', { error });
        }
    },
    async getAwaitingScreeningRecords(store: Store<ScreeningState>, screeningRecordPayLoad: ScreeningRecordPayLoad) {
        try {
            store.commit('GET_AWAITING_SCREENING_RECORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.getAwaitingStudyScreeningRecords(screeningRecordPayLoad);
            store.commit('GET_AWAITING_SCREENING_RECORDS', { data });
        } catch (error) {
            store.commit('GET_AWAITING_SCREENING_RECORDS', { error });
        }
    },
    async editCitationRecord(store: Store<ScreeningState>, citation: Citation) {

        try {
            store.commit('EDIT_CITATION_RECORD', ApiStatus.LOADING);
            const { data } = await screeningApi.editCitationRecord(citation);
            store.commit('EDIT_CITATION_RECORD', { data });
        } catch (error) {
            store.commit('EDIT_CITATION_RECORD', { error });
        }

    },
    async getStudiesByScreeningTypeStatus(store: Store<ScreeningState>, payload: GetStudiesByScreeningTypeStatusPayload) {
        try {
            store.commit('GET_STUDIES_BY_SCREENING_TYPE_STATUS', ApiStatus.LOADING);
            const { data } = await screeningApi.getStudiesByScreeningTypeStatus(payload);
            store.commit('GET_STUDIES_BY_SCREENING_TYPE_STATUS', { data });
        } catch (error) {
            store.commit('GET_STUDIES_BY_SCREENING_TYPE_STATUS', { error });
        }
    },
    async updateScreeningRecordCountOnRevertTeamDecision(store: Store<ScreeningState>, payload: StudyScreeningStatus) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_TEAM_DECISION',payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_TEAM_DECISION',error)
        }
    },
    async updateScreeningRecordsOnRevertTeamDecision(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_ON_REVERT_TEAM_DECISION', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_ON_REVERT_TEAM_DECISION', error);
        }
    },
    async getMyDecisionScreeningRecords(store: Store<ScreeningState>, payload: GetStudiesByUserIdPayload) {
        try {
            store.commit('GET_MY_DECISION_SCREENING_RECORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.getMyDecisionStudyScreeningRecords(payload);
            store.commit('GET_MY_DECISION_SCREENING_RECORDS', { data });
        } catch (error) {
            store.commit('GET_MY_DECISION_SCREENING_RECORDS', { error });
        }
    },

    async updateMyDecisionScreeningRecords(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_MY_DECISION_SCREENING_RECORDS', payload);
        } catch (error) {
            store.commit('UPDATE_MY_DECISION_SCREENING_RECORDS', error);
        }
    },

    async updateStudyScreeningStatus(store: Store<ScreeningState>, payload: UpdateStudyScreeningStatusPayload) {
        try {
            store.commit('UPDATE_STUDY_SCREENING_STATUS', ApiStatus.LOADING);

            const { data } = await screeningApi.updateStudyScreeningStatus(payload);
            store.commit('UPDATE_STUDY_SCREENING_STATUS', { data });
        } catch (error) {
            store.commit('UPDATE_STUDY_SCREENING_STATUS', { error });
        }
    },

    async updateScreeningRecords(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS', error)
        }
    },

    async updateScreeningRecordsCount(store: Store<ScreeningState>, payload: StudyScreeningStatus) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT', error)
        }
    },

    async updateScreeningRecordsCountOnMarkDuplicate(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_MARK_DUPLICATE',payload)
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_MARK_DUPLICATE',error);
        }
    },
    async updateScreeningRecordsCountOnRevertMyDecision(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_MY_DECISION', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_MY_DECISION', error);
        }
    },
    async revertStudyScreeningDecision(store: Store<ScreeningState>, payload: RevertStudyScreeningDecisionPayload) {
        try {
            store.commit('REVERT_STUDY_SCREENING_DECISION', ApiStatus.LOADING);

            const { data } = await screeningApi.revertStudyScreeningDecision(payload);
            store.commit('REVERT_STUDY_SCREENING_DECISION', { data });
        } catch (error) {
            store.commit('REVERT_STUDY_SCREENING_DECISION', { error });
        }
    },
    async revertMyDecisionScreeningRecords(store: Store<ScreeningState>, payload: Partial<StudyScreeningRecord>) {
        try {
            store.commit('REVERT_MY_DECISION_SCREENING_RECORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.revertMyDecisionStudyScreeningRecords(payload);
            store.commit('REVERT_MY_DECISION_SCREENING_RECORDS', { data });
        } catch (error) {
            store.commit('REVERT_MY_DECISION_SCREENING_RECORDS', { error });
        }
    },


    async getConflictedStudyScreeningRecords(store: Store<ScreeningState>, payload: GetStudiesByUserIdPayload) {
        try {
            store.commit('GET_CONFLICTED_SCREENING_RECORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.getConflictedStudyScreeningRecords(payload);
            store.commit('GET_CONFLICTED_SCREENING_RECORDS', { data });
        } catch (error) {
            store.commit('GET_CONFLICTED_SCREENING_RECORDS', { error });
        }
    },
    async getResolvedScreeningRecords(store: Store<ScreeningState>, payload: GetStudiesByUserIdPayload) {
        try {
            store.commit('GET_RESOLVED_SCREENING_RECORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.getResolvedStudyScreeningRecords(payload);
            store.commit('GET_RESOLVED_SCREENING_RECORDS', { data });
        } catch (error) {
            store.commit('GET_RESOLVED_SCREENING_RECORDS', { error });
        }
    },
    async updateResolvedScreeningRecords(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_RESOLVED_SCREENING_RECORDS', payload);
        } catch (error) {
            store.commit('UPDATE_RESOLVED_SCREENING_RECORDS', error)
        }
    },
    async updateScreeningRecordsCountOnRevertResolved(store: Store<ScreeningState>, payload: StudyScreeningStatus) {
        try {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_RESOLVED', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORDS_COUNT_ON_REVERT_RESOLVED', error);
        }
    },
    async revertResolved(store: Store<ScreeningState>, payload: RevertDecisionPayload) {
        try {
            store.commit('REVERT_RESOLVED', ApiStatus.LOADING);
            const { data } = await screeningApi.revertResolved(payload);
            store.commit('REVERT_RESOLVED', { data });
        } catch (error) {
            store.commit('REVERT_RESOLVED', { error });
        }
    },
    async resolveConflict(store: Store<ScreeningState>, payload: ResolveConflictPayload) {
        try {
            store.commit('RESOLVE_CONFLICT', ApiStatus.LOADING);
            const { data } = await screeningApi.resolveConflict(payload);
            store.commit('RESOLVE_CONFLICT', { data });
        } catch (error) {
            store.commit('RESOLVE_CONFLICT', { error });
        }
    },
    async updateConflictedScreeningRecords(store: Store<ScreeningState>, payload: Study) {
        try {
            store.commit('UPDATE_CONFLICTED_SCREENING_RECORDS', payload);
        } catch (error) {
            store.commit('UPDATE_CONFLICTED_SCREENING_RECORDS', error);
        }
    },
    async updateScreeningScreeningRecordCountOnResolveConflict(store: Store<ScreeningState>, payload: StudyScreeningStatus) {
        try {
            store.commit('UPDATE_SCREENING_RECORD_COUNT_ON_RESOLVE_CONFLICT', payload);
        } catch (error) {
            store.commit('UPDATE_SCREENING_RECORD_COUNT_ON_RESOLVE_CONFLICT', error);
        }
    },
    async mergeStudies(store: Store<ScreeningState>, payload: MergeStudiesPayload) {
        try {
            store.commit('MERGE_STUDIES', ApiStatus.LOADING);
            const { data } = await screeningApi.mergeStudies(payload);
            store.commit('MERGE_STUDIES', { data });
        } catch (error) {
            store.commit('MERGE_STUDIES', { error });
        }
    },
    async unmergedStudies(store: Store<ScreeningState>, payload: MergeStudiesPayload) {
        try {
            store.commit('UNMERGED_STUDIES', ApiStatus.LOADING);
            const { data } = await screeningApi.unmergedStudies(payload);
            store.commit('UNMERGED_STUDIES', { data });
        } catch (error) {
            store.commit('UNMERGED_STUDIES', { error });
        }
    },
    async getHighlightedKeywords(store: Store<ScreeningState>, projectId: number) {
        try {
            store.commit('GET_HIGHLIGHTED_KEYWORDS', ApiStatus.LOADING);
            const { data } = await screeningApi.getHighlightedKeywords(projectId);
            store.commit('GET_HIGHLIGHTED_KEYWORDS', { data });
        } catch (error) {
            store.commit('GET_HIGHLIGHTED_KEYWORDS', { error });
        }
    },
    toggleShowAbstract(store: Store<ScreeningState>) {
        try {
            store.commit('TOGGLE_SHOW_ABSTRACT_STATE');
        } catch (error) {
            store.commit('TOGGLE_SHOW_ABSTRACT_ERROR', { error });
        }
    },
    toggleKeywordHighlighted(store: Store<ScreeningState>) {
        try {
            store.commit('TOGGLE_KEYWORDS_HIGHLIGHTED_STATE');
        } catch (error) {
            store.commit('TOGGLE_KEYWORDS_HIGHLIGHTED_ERROR', { error });
        }
    },
}
